'use client';

import Script from 'next/script';
import type { PropsWithChildren } from 'react';

export default function KakaoInitializer({ children }: PropsWithChildren) {
	return (
		<>
			<Script
				src="https://t1.kakaocdn.net/kakao_js_sdk/2.7.1/kakao.min.js"
				integrity="sha384-kDljxUXHaJ9xAb2AzRd59KxjrFjzHa5TAoFQ6GbYTCAG0bjM55XohjjDT7tDDC01"
				crossOrigin="anonymous"
				defer
				onLoad={() => {
					Kakao.init(process.env.NEXT_PUBLIC_KAKAO_JAVASCRIPT_KEY);
					// console.log('\x1b[32;1mKakao SDK was Initialized!!\x1b[0m');
				}}
			/>
			{children}
		</>
	);
}
